import { render, staticRenderFns } from "./NoticeCard.vue?vue&type=template&id=68881f3c&scoped=true"
import script from "./NoticeCard.vue?vue&type=script&lang=js"
export * from "./NoticeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68881f3c",
  null
  
)

export default component.exports